import { getEmbedPathOr } from 'modules/embed/selectors'
import { getSession } from 'modules/session/selectors'
import { any, identity, memoizeWith } from 'ramda'
import { TeamUser } from 'types/embed'
import { getRandomIndex } from 'utils'

/**
 *
 * @description internal, should not be used directly!  Exposed for testing only.
 */
export const getRandomId = (team, doNotDisturbTeam, sessionStarted)=> {
  if (!team) {
    return null
  }

  let recipients = team.filter((member) => {
    return !member.bot
  })

  if (!!doNotDisturbTeam.length){
    const activeRecipients = recipients.filter((member) => {
      const dndTeamMember = any(m => m === member.id, doNotDisturbTeam)
      return !dndTeamMember
    })
    if (activeRecipients.length){
      recipients = activeRecipients
    }
  }

  const avatarRecipients = recipients.filter(member => !!member.avatarUrl)

  if (!!avatarRecipients.length) {
    recipients = avatarRecipients
  }

  // no users, return bot users
  if (!recipients.length) {
    return team[0].id
  }

  const recipientIndex = getRandomIndex(recipients.length, sessionStarted)

  return recipients[recipientIndex].id
}

export const getRandomTeamMemberId = memoizeWith((...args): any => identity(args),()=>{
  const session = getSession()
  const team: TeamUser[] = getEmbedPathOr([], ['configuration', 'team'])
  const doNotDisturbTeam: number[] = getEmbedPathOr([], ['configuration', 'doNotDisturbUsers'])

  return getRandomId(team, doNotDisturbTeam,session.sessionStarted)
})
